import { render, staticRenderFns } from "./GAXPMultiPolTypeHelplist.vue?vue&type=template&id=8644d37a&"
import script from "./GAXPMultiPolTypeHelplist.vue?vue&type=script&lang=js&"
export * from "./GAXPMultiPolTypeHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports